import { useCustomAlert } from "../alerts";
import useFetchAndTrace from "../fetchWithTrace";
import { useCallback, useState } from "react";
import settings from "../../../constants/settings";
import useFootprintForPart from "./forPart";

export default function useRemoveFootprintPartAssociation(
  partId: string | null,
) {
  const { refreshFootprint } = useFootprintForPart(partId);

  const customAlert = useCustomAlert();
  const fetchAndTrace = useFetchAndTrace();
  const [removing, setRemoving] = useState(false);

  const errorHandler = useCallback(() => {
    setRemoving(false);
    customAlert("Failed to remove footprint association");
  }, [customAlert]);

  const removeHandler = useCallback(
    async (response: Response) => {
      setRemoving(false);
      if (response.ok) {
        refreshFootprint();
      } else if (response.status === 404) {
        const { detail } = (await response.json()) as { detail: string };
        customAlert(detail);
      } else {
        throw Error("Failed to remove footprint association");
      }
    },
    [refreshFootprint, customAlert],
  );

  const removeFootprintPartAssociation = useCallback(
    (partId: string | null, footprintId: string) => {
      if (partId === null) {
        return;
      }
      setRemoving(true);
      void fetchAndTrace(
        `${settings.api_url}/footprints/part-association/${partId}/${footprintId}`,
        removeHandler,
        errorHandler,
        {
          method: "DELETE",
        },
      );
    },
    [errorHandler, fetchAndTrace, removeHandler],
  );

  return {
    removing,
    removeFootprintPartAssociation,
  };
}
